<template>
  <div class="viewurl-page-table">   
    <div class="page-product-table-box">
      <div class="page-header">
          <h2>{{$t('dsfx.t13')}}</h2>
      </div>
      <div class="searchwrap">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form :inline="true" class="table-form-inline search-left">
              <el-form-item>
                <el-button @click="chkviewmodel(2)" size="mini" :class="viewmodel == 2 ? 'chk-spu-sku chk-spu chk-spu-active' : 'chk-spu-sku chk-spu'"></el-button>
                <el-button @click="chkviewmodel(1)" size="mini" :class="viewmodel == 1 ? 'chk-spu-sku chk-sku chk-sku-active' : 'chk-spu-sku chk-sku'"></el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <div class="pricetablesearchline">
              <el-input 
                style="width:250px" 
                v-model="query.search" 
                :placeholder="$t('jgjk.s265')" 
                size="mini" 
                @keyup.enter.native="onTableListSaerch()"
              ></el-input>
              <el-button type="danger" @click="onTableListSaerch()" size="mini">{{ $t('dsfx.t26') }}</el-button>
            </div>            
          </el-col>
        </el-row>
      </div>
    </div>
    
    <div class="tablebox" v-if="viewmodel == 2">
      <el-table
        :data="tableData"
        :cell-style="this.getTableCellStyle"
        v-loading="tableloading" 
        tooltip-effect="dark" 
        style="width: 100%"
        @sort-change="sortthiscolumn"
        @expand-change="getProductList"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
        :key="2"
      >
        <el-table-column width="30" type="expand">
          <template slot-scope="scope">
            <div class="tablebox">
              <el-table
                :cell-style="getTableCellStyle"
                v-loading="tableloading1"
                :data="tableDataSku[scope.row.index]"
                tooltip-effect="dark" 
                style="width: 100%"
                border
                size="mini"
                stripe
              >
                <el-table-column prop="AssetId" label="ASSETID" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <a :href="scope.row.URL" target="_blank">
                      {{ scope.row.ProductName }}
                    </a>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('activebrand.t50')" width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.ShopName }}</a>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Infringements.t9')" width="80">
                  <template slot-scope="scope">
                    <i v-if="scope.row.daigou > 0" class="el-icon-success tableicontypes"></i>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('xfsp.sales')" prop='HighSales' width="80">
                  <template slot-scope="scope">
                    <i v-if="scope.row.highSales > 0" class="el-icon-success tableicontypes"></i>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Infringements.t10')" width="80">
                  <template slot-scope="scope">
                    <i v-if="scope.row.imgcheck > 0" class="el-icon-success tableicontypes"></i>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Infringements.t11')" prop='LowPrice' width="110">
                  <template slot-scope="scope">
                    <i v-if="scope.row.lowprice > 0" class="el-icon-success tableicontypes"></i>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('xfsp.keywords')" width="80">
                  <template slot-scope="scope">
                    <i v-if="scope.row.keyWords > 0" class="el-icon-success tableicontypes"></i>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Infringements.t12')" prop='TotalScore' width="80">
                  <template slot-scope="scope">
                    {{scope.row.TotalScore}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Infringements.t14')" prop="Qqfenlei" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    {{scope.row.Qqfenlei}}
                  </template>
                </el-table-column>
                <el-table-column prop="Suggestion" :label="$t('Infringements.t13')" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    {{scope.row.Suggestion}}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='spuid' label="SPUID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.URL" target="_blank">
              {{ scope.row.ProductName }}
            </a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('activebrand.t50')" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.ShopName }}</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t9')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.daigou > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('xfsp.sales')" prop='HighSales' width="80" sortable='custom'>
          <template slot-scope="scope">
            <i v-if="scope.row.highSales > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t10')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.imgcheck > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t11')" prop='LowPrice' width="110" sortable='custom'>
          <template slot-scope="scope">
            <i v-if="scope.row.lowprice > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('xfsp.keywords')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.keyWords > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
          <el-table-column prop='count' :label="$t('SPU.s2')" width="100"></el-table-column>
        <!-- <el-table-column :label="$t('Infringements.t12')" prop='TotalScore' width="80">
          <template slot-scope="scope">
            {{scope.row.TotalScore}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t14')" prop="Qqfenlei" show-overflow-tooltip width="100" sortable='custom'>
          <template slot-scope="scope">
            {{scope.row.Qqfenlei}}
          </template>
        </el-table-column>
        <el-table-column prop="Suggestion" :label="$t('Infringements.t13')" show-overflow-tooltip width="120" sortable='custom'>
          <template slot-scope="scope">
            {{scope.row.Suggestion}}
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    
    <div class="tablebox" v-if="viewmodel == 1">
      <el-table
        :data="tableDataskulist"
        :cell-style="this.getTableCellStyle"
        v-loading="tableloading2" 
        tooltip-effect="dark" 
        style="width: 100%"
        @sort-change="sortthiscolumn"
        :key="1"
      >
        <el-table-column prop='AssetId' label="ASSETID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.URL" target="_blank">
              {{ scope.row.ProductName }}
            </a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('activebrand.t50')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.ShopName }}</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t9')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.Daigou > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('xfsp.sales')" prop='HighSales' width="80" sortable='custom'>
          <template slot-scope="scope">
            <i v-if="scope.row.HighSales > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t10')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.ImgCheck > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t11')" prop='LowPrice' width="110" sortable='custom'>
          <template slot-scope="scope">
            <i v-if="scope.row.LowPrice > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('xfsp.keywords')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.KeyWords > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t12')" prop='TotalScore' width="80">
          <template slot-scope="scope">
            {{scope.row.TotalScore}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t14')" prop="Qqfenlei" show-overflow-tooltip width="100" sortable='custom'>
          <template slot-scope="scope">
            {{scope.row.Qqfenlei}}
          </template>
        </el-table-column>
        <el-table-column prop="Suggestion" :label="$t('Infringements.t13')" show-overflow-tooltip width="120" sortable='custom'>
          <template slot-scope="scope">
            {{scope.row.Suggestion}}
          </template>
        </el-table-column>
      </el-table>
    </div>    

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="query.size"
        layout="total, prev, pager, next, sizes"
        :total="viewmodel == 1 ? pagingtotalsku : pagingtotalspu">
      </el-pagination>      
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      getRowKeys(row){
        return row.index
      },
      expands: [],
      searchNeedle: '',
      query: {
        skuid: this.$route.params.SkuId,
        page: 1,
        size: 25,
        search: '',
        order: '01',
        taskid: ''
      },
      tableloading: false,
      tableloading1: false,
      tableloading2: false,
      tableData: [],
      tableDataSku: [],
      tableDataskulist: [],
      pagingtotal: 0,
      pagingtotalspu: 0,
      pagingtotalsku: 0,
      currentPage: 1,
      multipleSelection: [],
      ischeckeditems: false,
      downloadarr: '',
      viewmodel: 2 //1 sku,2 spu
    }
  },

  mounted(){
    let skuinfo = JSON.parse(localStorage.getItem("SPUecommercedefenseviewurl")).val
    this.viewmodel = localStorage.getItem("viewmodel") ? JSON.parse(localStorage.getItem("viewmodel")).val : 2
    this.query.taskid = skuinfo.taskid
    this.getPagelist()
    this.getPagelistSKU()
  },

  methods: {

    /**
     * 搜索
     */
    onTableListSaerch: function(){
      this.getPagelist()
    },

    /**
     * handleSizeChange
     */
    handleSizeChange: function(val){
      this.currentPage = 1
      this.query.page = 1
      this.query.size = val
      if(this.viewmodel == 1){
        this.getPagelistSKU()
      }
      if(this.viewmodel == 2){
        this.getPagelist()
      }
    },

    /**
     * handleCurrentChange
     */
    handleCurrentChange: function(val){
      this.query.page = val
      if(this.viewmodel == 1){
        this.getPagelistSKU()
      }
      if(this.viewmodel == 2){
        this.getPagelist()
      }
    },

    /**
     * 选中数据
     */
    handleSelectionChange: function(val){
      this.multipleSelection = val
      let selectionids = this.multipleSelection
      selectionids = selectionids.map(item => {return item.AssetId})
      this.downloadarr = selectionids.join(',')
      if(this.downloadarr != ''){
        this.ischeckeditems = true
      }else{
        this.ischeckeditems = false
      }
    },

    /**
     * Paging
     */
    getPagelist: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/spudetail/paging'
      let data = that.query
      that.tableloading = true
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getPagelist', rex)
          let tablelists = rex.results[1]
          tablelists.forEach( (item, index) => {
            item.TotalScore = that.setLevels(item.TotalScore)
            item.Qqfenlei = that.setInfringementsType(item.Qqfenlei).txt
            item.Suggestion = that.setInfringementsSuggestion(item.Suggestion).txt
            item.index = index
          })
          that.tableData = tablelists
          that.pagingtotalspu = rex.results[0][0].Count
          that.tableloading = false
        },
        error: function(response) {
          console.log('getPagelist', response)
        }
      })      
    },

    /**
     * 已下载的数据不能下载
     */
    selectable(row) {
      if(row.downStatus === null || row.downStatus/1 === 0){
        return true
      }else{
        return false
      }      
    },

    /**
     * 列表排序
     */
    sortthiscolumn: function(column){
      console.log(column)
      if(column.prop == "HighSales" && column.order == "ascending"){
        this.query.order = '00'
        this.getPagelist()
      }else if(column.prop == "HighSales" && column.order == "descending"){
        this.query.order = '01'
        this.getPagelist()
      }else if(column.prop == "HighSales" && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == "ascending"){
        this.query.order = '10'
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == "descending"){
        this.query.order = '11'
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == "ascending"){
        this.query.order = '20'
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == "descending"){
        this.query.order = '21'
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == "ascending"){
        this.query.order = '30'
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == "descending"){
        this.query.order = '31'
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == "ascending"){
        this.query.order = '40'
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == "descending"){
        this.query.order = '41'
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else{
        return
      }
    },

    /**
     * 获取单品链接
     */
    getProductList: function(row){
      let that = this
      let url = this.API_URL + '/v3/commerce/spudetail/getlist'
      let query = {
        skuid: that.$route.params.SkuId,
        page: 1,
        size: 1000,
        itemcode: row.ItemCode,
        channelid: row.ChannelId
      }

      let _c = this.expands
      if(row.index == _c[0]) return
      this.expands = []
      this.expands.push(row.index)

      that.tableloading1 = true
      $.ajax({
        url:  url,
        type: "GET",
        data: query,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log(rex)
          let _list = rex.results[1]
          that.tableDataSku[row.index] = _list
          that.tableloading1 = false
        },
        error: function(response) {
          console.log(response)
        }
      })
    },
    
    /**
     * 切换浏览模式
     */
    chkviewmodel: function(typeid){
      this.viewmodel = typeid
      this.setLocalStorage( "viewmodel", typeid )
      this.query.page = 1
      if(this.viewmodel == 1){
        this.tableDataskulist = []
        this.getPagelistSKU()
      }
      if(this.viewmodel == 2){
        this.tableData = []
        this.tableDataSku = []
        this.getPagelist()
      }
    },

    /**
     * Paging
     */
    getPagelistSKU: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/detail/paging'
      let data = that.query
      that.tableloading2 = true
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getPagelistSKU', rex)
          let tablelists = rex.results[1]
          tablelists.forEach( item => {
            item.TotalScore = that.setLevels(item.TotalScore)
            item.Qqfenlei = that.setInfringementsType(item.Qqfenlei).txt
            item.Suggestion = that.setInfringementsSuggestion(item.Suggestion).txt
          })
          that.tableDataskulist = tablelists
          that.pagingtotalsku = rex.results[0][0].Count
          that.tableloading2 = false
        },
        error: function(response) {
          console.log('getPagelist', response)
        }
      })      
    },

  }
}
</script>